module.exports = __webpack_public_path__ + "img/img-hero-mobile.1dc8886a.jpg";